import * as React from 'react';
const SvgPlusBoxIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={20} fill="none" {...props.svgProp}>
    <path
      d="M10.997 6.667v6.666M7.663 10h6.667m-6.833 7.5h7c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.092-1.092c.273-.535.273-1.235.273-2.635v-7c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 0 0-1.092-1.093c-.535-.272-1.235-.272-2.635-.272h-7c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.093 1.093C3.497 4.4 3.497 5.1 3.497 6.5v7c0 1.4 0 2.1.272 2.635a2.5 2.5 0 0 0 1.093 1.092c.534.273 1.234.273 2.635.273Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props.pathProp}
    />
  </svg>
);
export default SvgPlusBoxIcon;
